import React from 'react';
import { DashboardFieldsProvider } from 'domain/shared/core/dashboard';
import { ControlledShow, useShowContext } from 'framework/show';
import StaffingDashboardExpandedItemWrapper from '../components/StaffingDashboardExpandedItemWrapper';
import StaffingProjectItemCollapsed from './StaffingProjectItemCollapsed';
import StaffingDashboardModalsProvider from '../components/StaffingDashboardModalsProvider';
import { Grid2 as Grid } from '@mui/material';
import { LinkField } from 'framework/ui/field';
import StaffingProjectGeneralInfo from './StaffingProjectGeneralInfo';
import { StaffingDataType } from 'domain/shared/staffing';
import { useStaffingDashboardCallbacks } from '../hooks/useStaffingDashboardCallbacks';
import StaffingBottomContent from './StaffingBottomContent';
import { getStaffingProjectUrl } from 'domain/shared/project';
import { DashboardItem } from 'framework/ui/dashboard';

interface StaffingProjectItemProps {
  project: StaffingDataType;
  onUpdate?: (project: StaffingDataType) => void;
}

const StaffingProjectItemContent = () => {
  const { data } = useShowContext<StaffingDataType>();
  const projectData = data.getData();
  const itemId = projectData.alias || projectData.id.toString();
  const projectPath = getStaffingProjectUrl(projectData.id.toString());

  const dashboardCallbacks = useStaffingDashboardCallbacks();

  const collapsedComponent = <StaffingProjectItemCollapsed projectPath={projectPath} projectName={projectData.name} />;

  const expandedComponent = (
    <StaffingDashboardExpandedItemWrapper bottomContent={<StaffingBottomContent />}>
      <Grid container spacing={1.2}>
        <Grid size={{ xs: 12 }} sx={{ a: { fontWeight: 700 } }}>
          <LinkField value={projectPath} linkText={projectData?.name} label="" />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <StaffingProjectGeneralInfo />
        </Grid>
      </Grid>
    </StaffingDashboardExpandedItemWrapper>
  );

  return (
    <DashboardFieldsProvider {...dashboardCallbacks}>
      <DashboardItem itemId={itemId} collapsedComponent={collapsedComponent} expandedComponent={expandedComponent} />
    </DashboardFieldsProvider>
  );
};

const StaffingProjectItem: React.FC<StaffingProjectItemProps> = ({ project, onUpdate }) => {
  return (
    <ControlledShow data={project} setData={onUpdate}>
      <StaffingDashboardModalsProvider>
        <StaffingProjectItemContent />
      </StaffingDashboardModalsProvider>
    </ControlledShow>
  );
};

export default StaffingProjectItem;
